import { render, staticRenderFns } from "./SkillDiagram.vue?vue&type=template&id=d0b0aa1c&"
import script from "./SkillDiagram.vue?vue&type=script&lang=ts&"
export * from "./SkillDiagram.vue?vue&type=script&lang=ts&"
import style0 from "./SkillDiagram.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports